module.exports = __webpack_public_path__ + "static/img/84023H_R_02_20170815_LC.51f9a03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/84023H_R_02_20170815_LC.png
// module id = ti4L
// module chunks = 0